export const ADD_TO_BASKET = 'ADD_TO_BASKET'
export const REMOVE_FROM_BASKET = 'REMOVE_FROM_BASKET'
export const CLEAR_BASKET = 'CLEAR_BASKET'

export const REDEEM_PROMO_CODE = 'REDEEM_PROMO_CODE'
export const REDEEMED_PROMO_CODE = 'REDEEMED_PROMO_CODE'
export const REMOVE_PROMO_CODE = 'REMOVE_PROMO_CODE'
export const SET_AUTO_RENEW = 'SET_BASKET_AUTO_RENEW'

export const MAKE_PURCHASE = 'MAKE_PURCHASE'
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS'
export const PAYMENT_CANCELLED = 'PAYMENT_CANCELLED'
export const PAYMENT_ERROR = 'PAYMENT_ERROR'
export const PURCHASE_COMPLETED = 'PURCHASE_COMPLETED'
export const CLEAR_PURCHASE_COMPLETED = 'CLEAR_PURCHASE_COMPLETED'
export const EXTEND_PURCHASE_COMPLETED = 'EXTEND_PURCHASE_COMPLETED'
export const PURCHASE_ERROR = 'PURCHASE_ERROR'
